import { v4 } from 'uuid';
import { makeAutoObservable, reaction } from "mobx"
import { load, save } from './persist';

const _type = 'discountToken';

// A claim token is a 64-byte ed25519 signature (algosdk.signBytes), base64-encoded
// to 88 chars. Earlier years used a different token format/length, so a token left
// in localStorage from a previous birthday must not be loaded as this year's — it
// would be confused for a valid one and fail on-chain. Reject anything that isn't a
// string of exactly the expected length.
const EXPECTED_TOKEN_LENGTH = 88;

function isValidToken(val) {
  return typeof val === 'string' && val.length === EXPECTED_TOKEN_LENGTH;
}

class DiscountToken {
  token = null

  constructor(newObj) {
    makeAutoObservable(this);

    load(_type, (val) => {
      if (isValidToken(val)) {
        this.setToken(val);
      } else if (val != null) {
        // Stale/foreign token (e.g. last year's) — drop it so it can't be reused.
        console.log('Ignoring localStorage discountToken with unexpected length', val?.length);
        localStorage.removeItem(_type);
      }
    });

    reaction(() => this.token, (newValue, prevValue) => {
      console.log('saving token', this.token);
      save(_type, this.token);
    });
  }

  setToken(token) {
      console.log('setting token', this.token);
    this.token = token;
  }
}

export default DiscountToken;
